<template>
  <div>
    <div class="camera-box" :class="{ flash: isShotPhoto }">
      <div class="camera-shutter" :class="{ flash: isShotPhoto }"></div>
      <video
        v-show="!isPhotoTaken"
        ref="camera"
        width="100%"
        height="100%"
        autoplay
      ></video>
      <canvas
        v-show="false"
        id="photoTaken"
        ref="canvas"
        width="1024"
        height="768"
      ></canvas>
      <img alt :src="snapshot" width="100%" />
    </div>

    <div class="text-center">
      <v-btn fab small light @click="onCancel" color="white" title="Назад">
        <v-icon> mdi-arrow-left </v-icon>
      </v-btn>
      <v-btn large fab @click="onTakePhoto" class="left20">
        <v-icon dark> mdi-camera-outline </v-icon>
      </v-btn>
      <v-btn
        fab
        small
        light
        @click="onGoHome"
        class="left20"
        color="white"
        title="На главную"
      >
        <v-icon> mdi-home-import-outline </v-icon>
      </v-btn>
    </div>

    <div v-if="isPhotoTaken" class="camera-save"></div>

    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  </div>
</template>

<script>
import ConfirmDialogue from "@/components/ConfirmDialogue.vue";

export default {
  name: "TakePhoto",
  components: { ConfirmDialogue },
  props: ["draftUkdUuid"],
  data: function () {
    return {
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      snapshot: "",
    };
  },
  beforeMount() {
    this.toggleCamera();
  },
  methods: {
    onCancel() {
      this.stopCameraStream();
      this.$emit("openCamera", false);
    },
    onGoHome() {
      this.stopCameraStream();
      this.$store.commit("clearUpd");
      this.$store.commit("clearCanceledGoods");
      this.$router.push({ name: "Home" });
    },
    toggleCamera() {
      this.createCameraElement();
    },
    createCameraElement() {
      this.isLoading = true;

      const constraints = (window.constraints = {
        audio: false,
        // video: true,
        video: { facingMode: { exact: "environment" } },
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.isLoading = false;
          this.$refs.camera.srcObject = stream;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();
      tracks.forEach((track) => {
        track.stop();
      });
    },
    onTakePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;
        const FLASH_TIMEOUT = 50;
        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;
      const context = this.$refs.canvas.getContext("2d");
      context.drawImage(this.$refs.camera, 0, 0, 1024, 768);

      let snapshotImg = new Image();
      snapshotImg.src = document
        .getElementById("photoTaken")
        .toDataURL("image/jpeg", 1); //Second param is jpg quality
      this.snapshot = snapshotImg.src;
      this.$emit("draftImage", snapshotImg.src);

      this.$refs.confirmDialogue
        .show({
          title: "Передать фото",
          message: "Прикрепить это фото?",
          okButton: "ОК",
        })
        .then((result) => {
          if (result) {
            this.stopCameraStream();
            this.$store
              .dispatch("send_media", {
                img: snapshotImg.src,
                draftUkdUuid: this.draftUkdUuid,
              })
              .then((res) => {
                this.$store.dispatch("setCurrentUkdImageLink", res["@id"]);
              });
            this.$emit("openCamera", false);
          } else {
            this.createCameraElement();
          }
        })
        .finally(() => {
          this.snapshot = "";
          this.isPhotoTaken = false;
        });
    },
  },
};
</script>
